import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '../Icon/Icon';
import { PlainButton } from '../PlainButton/PlainButton';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
export const ExpansionTableTitleWithSort = ({ titleText, sortName, sort, onSort, }) => {
    const handleSort = () => {
        onSort(sortName);
    };
    const sortIconName = sort.order === 'ASC' ? 'ArrowUpward' : 'ArrowDownward';
    const maybeSortIcon = sortName === sort.name ? _jsx(Icon, { name: sortIconName }) : null;
    const expansionTableTitle = (_jsx(PlainButton, { onClick: handleSort, children: _jsxs(FlexContainer, { direction: 'row', gap: '1', verticalAlign: 'center', children: [_jsx(Text, { variant: 'b2', underline: true, children: titleText }), maybeSortIcon] }) }));
    return expansionTableTitle;
};
